// RouterView.jsx
import React from 'react';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Link
} from 'react-router-dom';
import App from './App';
import MainApp from './MainApp';
import About from './pages/About';
import HowToUse from './pages/HowToUse';
import Privacy from './pages/Privacy';
import FAQ from './pages/FAQ';
import TrailRunningBasics from './pages/TrailRunningBasics';
import Contact from './pages/Contact';
import BlogList from './pages/BlogList';
import BlogArticle from './pages/BlogArticle';
import AffordableGear from './pages/AffordableGear';

import Run3D from './components/Run3D';   // ← ★ 追加

export default function RouterView() {
  return (
    <Router>
      <Routes>
        <Route
          path="/"
          element={
            <App>
              <MainApp />
            </App>
          }
        />
        {/* ← ★★★ ここに追加 ★★★ */}
        <Route
          path="/run3d"
          element={
            <App>
              <Run3D />
            </App>
          }
        />
        <Route
          path="/about"
          element={
            <App>
              <About />
            </App>
          }
        />
        <Route
          path="/how-to-use"
          element={
            <App>
              <HowToUse />
            </App>
          }
        />
        <Route
          path="/privacy"
          element={
            <App>
              <Privacy />
            </App>
          }
        />
        <Route
          path="/faq"
          element={
            <App>
              <FAQ />
            </App>
          }
        />
        <Route
          path="/basics"
          element={
            <App>
              <TrailRunningBasics />
            </App>
          }
        />
        <Route
          path="/contact"
          element={
            <App>
              <Contact />
            </App>
          }
        />
        <Route
          path="/blog"
          element={
            <App>
              <BlogList />
            </App>
          }
        />
        <Route
          path="/blog/:id"
          element={
            <App>
              <BlogArticle />
            </App>
          }
        />
        <Route
          path="/AffordableGear"
          element={
            <App>
              <AffordableGear  />
            </App>
          }
        />
      </Routes>
    </Router>
  );
}
